<script>
    import PublishLayerSelect from "./publish-layer-select.vue";
    import PublishPublishButton from "./button/publish-publish-button.vue";
    import PublishFilterSelect from "./publishFilterSelect.vue";
    import PublishApproveAllButton from "./button/publish-approve-all-button.vue";
    import PublishPreviewButton from "./button/publish-preview-button.vue";
    import PublishJumpToDateButton from "./button/publish-jump-to-date-button.vue";

    export default {
        name: "publish-calendar-actionbar",
        components: {PublishJumpToDateButton, PublishPreviewButton, PublishApproveAllButton, PublishFilterSelect, PublishPublishButton, PublishLayerSelect},
        props: {
            /** @type CalendarPublishLayer */
            activeLayer: {},
            activeScreenId: String,
            allScreens: Array,
            layers: Array,
            loading: Boolean,
            dialogText: String,
            dialogAdditionalText: String,
            publishingDisabled: Boolean,
            currentEvents: Array,
        },
        emits: ['layerChanged', 'screenChanged', 'disapproveAll', 'approveAll', 'publish'],
        computed: {
            label() {
                return Lang.langChoice('Screen|Screens', 1)
            },
            activeLayerIndex() {
                return this.layers.findIndex(layer => layer.id === this.activeLayer.id);
            },
            selectableLayers() {
                return this.layers.map((layer, index) => ({...layer, value: index}));
            },
        },
        methods: {
            handleDateSelected(date) {
                EaseEventBus.fire('calendar-goToDate', date);
            }
        }
    }
</script>

<template>
    <div class="calendar-actionbar">
        <publish-layer-select
            :activeLayerIndex="activeLayerIndex"
            :selectableLayers="selectableLayers"
            @input="$emit('layerChanged', $event)"
        />
        <publish-filter-select
            :items="allScreens"
            :selected-item="activeScreenId"
            :label="label"
            :clearable="false"
            @input="$emit('screenChanged', $event)"
        />
        <publish-jump-to-date-button
            :events="currentEvents"
            @dateSelected="handleDateSelected"
        />
        <publish-approve-all-button
            :elements="activeLayer.elements"
            @approve="$emit('approveAll')"
            @disapprove="$emit('disapproveAll')"
        />
        <publish-preview-button
            :disabled="!activeLayer.elements.length"
            :layer="activeLayer"
            :elements="activeLayer.elements"
            :screen-id="activeScreenId"
        />
        <publish-publish-button
            :disabled="publishingDisabled"
            :loading="loading"
            :dialogText="dialogText"
            :dialogAdditionalText="dialogAdditionalText"
            color="primary"
            @publish="$emit('publish', $event)"
        />
    </div>
</template>

<style scoped>
    .calendar-actionbar {
        padding: 12px;
        display: flex;
        align-items: center;
        gap: 0.5rem;
    }

    .calendar-actionbar .v-autocomplete {
        margin-right: 8px;
    }
</style>
